import request from '@/utils/request'
import { CodeItem } from './types'

// moms BE 공통 코드 — 국가/물류카테고리 차원은 mass가 소유하지 않으므로 moms BE에서 조회한다.
// (mass-settlement PR #451 리뷰: /codes 에서 countries·logisticsCategories 제거)
// NOTE: 아래 엔드포인트는 moms BE 계약 가정값. 실제 경로 확정 시 이 파일만 수정하면 됨.
export const getCountries = async () => await request.get<ApiResponseV2<{ items: CodeItem[] }>>('/api/v1/codes/countries')

// 물류카테고리 전체 목록(category#### 평면) — 단일 검색 select용
export const getLogisticsCategories = async () =>
  await request.get<ApiResponseV2<{ items: CodeItem[] }>>('/api/v1/codes/logistics-categories')
